/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { IndexDependencies } from './dependenciesIndexClass.generated.js';
import { compareNaturalDependencies } from './dependenciesCompareNatural.generated.js';
import { sizeDependencies } from './dependenciesSize.generated.js';
import { subsetDependencies } from './dependenciesSubset.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSetIsSubset } from '../../factoriesAny.js';
export var setIsSubsetDependencies = {
  IndexDependencies,
  compareNaturalDependencies,
  sizeDependencies,
  subsetDependencies,
  typedDependencies,
  createSetIsSubset
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSetIsSubset.generated.js
// module id = sEQY
// module chunks = 3